.<template>
    <div class="components-container">
        <el-row class="courseContent">
            <el-table
                :data="CAPS"
                ref="CAPTable"
                :header-cell-style="{'text-align':'center','blackground-color':'#f1faf6'}"
                element-loading-text="信息加载中"
                border
                class="tb-edit"
                fit
                highlight-current-row
                style="width: 100%"
                height="600px"
                @selection-change="handleCoursesSelection"
                :row-style="{ 'height':'64px' }"
                @row-click="(row, column, event) => handleRowClick('CAPTable', row, column, event)"
            >
                <!-- <el-table-column label="课程类型" prop="courseKind" width="180" align="center">
                    <template slot-scope="scope">
                        <span class="el-edit">
                            <el-select v-model="scope.row.courseKind"
                                placeholder="请选择"
                                @visible-change="handleCourseTypeOptionVisible(scope)"
                                @change="handleCourseTypeChange(scope)">
                                <el-option v-for="(item, index) in kinds"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </span>
                        <span>{{ scope.row.courseTypeName }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="课程属性" prop="courseProperties" width="180" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.coursePropertiesName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="课程名称" min-width="220">
                    <template slot-scope="scope">
                        <span>{{ scope.row.courseName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="课程类别" width="80" align="center" prop="courseCategoryName">
                    <template slot-scope="scope">
                        <span>{{ scope.row.courseCategoryName }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column v-if="true" label="是否进阶课程" width="90" align="center" prop="sfjjkc">
                    <template slot-scope="scope">
                        <span>{{ scope.row.sfjjkcmc }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="学分" width="90" align="center" prop="score">
                    <template slot-scope="scope">
                        <span>{{ formatterNumShow(scope.row.score) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="总学时" width="90" align="center" prop="totalTime">
                    <template slot-scope="scope">
                        <span>{{ formatterNumShow(scope.row.totalTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="理论教学" width="90" prop="theoryTime" align="center">
                    <template slot-scope="scope">
                        <span>{{ formatterNumShow(scope.row.theoryTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="实验实训" width="90" prop="practiseTime" align="center">
                    <template slot-scope="scope">
                        <span>{{ formatterNumShow(scope.row.practiseTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="考核方式" width="90" prop="examType" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.examTypeName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="各学期周数、学时分配" align="center">
                    <el-table-column label="一">
                        <el-table-column :label="weeks.first" prop="term1" align="center" width="60">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.term1,scope.row.week1) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="二">
                        <el-table-column :label="weeks.second" prop="term2" align="center" width="60">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.term2,scope.row.week2) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="三">
                        <el-table-column :label="weeks.third" prop="term3" align="center" width="60">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.term3,scope.row.week3) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="四">
                        <el-table-column :label="weeks.fourth" prop="term4" align="center" width="60">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.term4,scope.row.week4) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="五">
                        <el-table-column :label="weeks.fifth" prop="term5" align="center" width="60">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.term5,scope.row.week5) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="六">
                        <el-table-column :label="weeks.sixth" prop="term6" align="center" width="60">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.term6,scope.row.week6) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="七">
                        <el-table-column :label="weeks.seventh" prop="term7" align="center" width="60">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.term7,scope.row.week7) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="八">
                        <el-table-column :label="weeks.eighth" prop="term8" align="center" width="60">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.term8,scope.row.week8) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="九">
                        <el-table-column :label="weeks.ninth" prop="term9" align="center" width="60">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.term9,scope.row.week9) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="十">
                        <el-table-column :label="weeks.tenth" prop="term10" align="center" width="60">
                            <template slot-scope="scope">
                                <span>{{ formatterNumHour(scope.row.term10,scope.row.week10) }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </el-row>
        <div slot="footer" class="dialog-footer" style="margin-top:10px;float:right;">
            <el-button type="primary" @click="submitJxjc">确 定</el-button>
            <el-button @click="closeJxjcDialog">取 消</el-button>
        </div>
    </div>

</template>


<script>
import relatedCourseConfig from './relatedCourseConfig';

export default {
    props: ['courseComboInfo', 'editDisableState'],
    components: {
        relatedCourseConfig,
    },
    data() {
        return {
            teachingSchemeCode: null,
            kind: "01",
            CAPS: [],
            CAPSMult: [],
            kinds: [],
            kcsx: [],
            examType: [],
            optionCourses: [],//课程数据
            tempOptionCourses: [],//临时课程数据
            filterOptionCourses: [],//显示前30条课程数据
            oldCourseName: "",
            oldCourseType: "",
            oldCourseProperties: "",
            oldCourseProperties: "",
            weeks: {
                first: "18周",
                second: "18周",
                third: "18周",
                fourth: "18周",
                fifth: "18周",
                sixth: "18周",
                seventh: "18周",
                eighth: "18周",
                ninth: "18周",
                tenth: "18周",
            },
            renderFlag: true,
            dialogVisible: false,
            courseCode: null,
            selectCourseId: null,
            jxjcRowData: null,
        };
    },
    mounted() {
        this.$nextTick().then(() => {
            //固定表头位置
            $('.courseContent .el-table .el-table__header-wrapper').css('position', '-webkit-sticky');
            $('.courseContent .el-table .el-table__header-wrapper').css('position', 'sticky');
            $('.courseContent .el-table .el-table__header-wrapper').css('top', '45px');
            $('.courseContent .el-table .el-table__header-wrapper').css('z-index', '9999');
        });
    },
    methods: {
        addCAP() {
            if(this.courseComboInfo.length == 0){
                this.$alert("请先选择主要信息", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }
            let origin = {
                id: this.getId(6),
                courseId: null,
                courseName: null,
                fullName: null,
                courseKind: "",
                courseProperties: "",
                coursePropertiesName: "",
                courseCategoryName: "",
                sfjjkc: "",
                sfjjkcmc: "",
                examType: '01',
                examTypeName: '试',
                totalTime: 0,
                score: 0,
                theoryTime: 0,
                practiseTime: 0,
                term1: 0,
                term2: 0,
                term3: 0,
                term4: 0,
                term5: 0,
                term6: 0,
                term7: 0,
                term8: 0,
                term9: 0,
                term10: 0,
            };
            let copy = { ...origin };
            this.CAPS.push(copy);
        },
        operation(scope) {
            let query = scope.row.courseId;
            if (query == null) {
                this.$notify({
                    title: "错误",
                    message: "请先选择课程信息",
                    type: "error",
                    duration: 3000,
                });
                return;
            }
            this.$emit("openWindow", query);
        },
        relatedCourseConfig(rowData){
            this.courseCode = rowData.courseId;
            if(this.courseCode==null || this.courseCode==''){
                this.$alert("请先选择课程信息", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }

            this.dialogVisible = true;
        },
        loadComboOption(mode) {
            let param = {
                mode: mode,
            };
            this.$api.teachingManage.teachingScheme.loadComboOption({
                data: param,
            }).then((res) => {
                this.kinds = res.data.data.courseType;
                this.examType = res.data.data.examType;
                this.kcsx = res.data.data.courseProperties;
            }).catch((err) => {
                console.log(err);
            });
        },
        handleCoursesSelection(val) {
            this.CAPSMult = val;
        },
        popGrid() {
            if (this.CAPSMult.length === 0) return;

            this.restoreOptions();

            this.arrayMinus(this.CAPS, this.CAPSMult);

            this.$nextTick(() => {
                this.$refs.CAPTable.clearSelection();
            });
        },
        restoreOptions() {
            this.CAPSMult.forEach((item) => {
                this.setDisable(this.courseComboInfo[item.courseProperties], item.fullName);
            });
        },
        setDisable(course, fullName) {
            if(course!=undefined){
                course.forEach((item) => {
                    if (item.value === fullName) item.disabled = false;
                });
            }
        },
        getId(length) {
            return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
        },
        arrayMinus(arr1, arr2) {
            //arr1 - arr2
            arr1.forEach((item) => {
                item.id = this.getId();
            });
            arr2.forEach((item) => {
                item.id = this.getId();
            });
            for (let i = arr1.length - 1; i >= 0; i--) {
                let x = arr1[i].id;
                for (let k = arr2.length - 1; k >= 0; k--) {
                    if (arr2[k].jkKclx === "0") continue;
                    let y = arr2[k].id;
                    if (x == y) {
                        arr1.splice(i, 1);
                        arr2.splice(k, 1);
                        break;
                    }
                }
            }
        },
        handleCourseTypeOptionVisible(scope) {
            this.oldCourseType = scope.row.courseKind;
        },
        handleCourseTypeChange(scope) {
            //修改课程类型时，恢复原来选择的课程的可选状态
            let tempCourseName = scope.row.fullName;
            let tempCourseComboData = [];
            if(this.oldCourseType != ''){
                tempCourseComboData = this.courseComboInfo[this.oldCourseType];
            }

            scope.row.fullName = null;
            for (let i=0; i<tempCourseComboData.length; ++i) {
                if (tempCourseComboData[i].value === tempCourseName) {
                    tempCourseComboData[i].disabled = false;
                    break;
                }
            }

            let courseTypeCode = scope.row.courseKind;
            let courseTypeName = '';
            for(let i=0; i<this.kinds.length; i++){
                if(courseTypeCode === this.kinds[i].value){
                    courseTypeName = this.kinds[i].label;
                    break;
                }
            }
            scope.row.courseTypeName = courseTypeName;
        },
        handleCoursePropertiesOptionVisible(scope){
            this.oldCourseProperties = scope.row.courseProperties;
        },
        handleCoursePropertiesChange(scope){
            if(scope.row.courseProperties=="01"||scope.row.courseProperties=="02"||scope.row.courseProperties=="03"){
                scope.row.courseKind = "01";
            }else{
                scope.row.courseKind = "02";
            }

            //修改课程属性时，恢复原来选择的课程的可选状态
            let tempCourseName = scope.row.fullName;
            let tempCourseComboData = [];
            if(this.oldCourseProperties != ''){
                tempCourseComboData = this.courseComboInfo[this.oldCourseProperties];
            }

            scope.row.fullName = null;
            for (let i=0; i<tempCourseComboData.length; ++i) {
                if (tempCourseComboData[i].value === tempCourseName) {
                    tempCourseComboData[i].disabled = false;
                    break;
                }
            }

            let coursePropertiesCode = scope.row.courseProperties;
            let coursePropertiesName = '';
            for(let i=0; i<this.kcsx.length; i++){
                if(coursePropertiesCode === this.kcsx[i].comboValue){
                    coursePropertiesName = this.kcsx[i].comboName;
                    break;
                }
            }
            scope.row.coursePropertiesName = coursePropertiesName;
        },
        handleCourseFocus(scope) {
            this.selectCourseId = (scope.row.courseId+'-'+scope.row.courseName);
            //获得焦点时 改变下拉框的值
            this.tempOptionCourses = [];
            this.filterOptionCourses = [];
            this.optionCourses = this.courseComboInfo[scope.row.courseProperties];
            for(let i=0;i<this.optionCourses.length;i++){console.log(scope.row.courseId+"||"+this.optionCourses[i].value);
                if((scope.row.courseId+'-'+scope.row.courseName) == this.optionCourses[i].value){
                    this.tempOptionCourses.push(this.optionCourses[i]);// 保存选中课程
                    this.filterOptionCourses.push(this.optionCourses[i]);// 保存选中课程
                }
            }
            for(let i=0;i<this.optionCourses.length;i++){
                if((scope.row.courseId+'-'+scope.row.courseName) != this.optionCourses[i].value){
                    this.tempOptionCourses.push(this.optionCourses[i]);
                    if(i<30){
                        this.filterOptionCourses.push(this.optionCourses[i]);// 只显示前30条
                    }
                }
            }
        },
        // 自定义el-select的搜索实现方法
        searchFilterCourse(val) {
            let searchOptionCourse = [];
            for(let i=0;i<this.tempOptionCourses.length;i++){
                if(this.selectCourseId == this.tempOptionCourses[i].value){
                    searchOptionCourse.push(this.tempOptionCourses[i]);// 保存选中课程
                }
            }
            for(let i=0;i<this.tempOptionCourses.length;i++){
                if(this.tempOptionCourses[i].value.includes(val)){
                    searchOptionCourse.push(this.tempOptionCourses[i]);
                }
            }

            // 根据检索条件筛选出来的选项，只取前30条
            if (searchOptionCourse.length > 30) {
                this.filterOptionCourses = searchOptionCourse.slice(0, 30)
            } else {
                this.filterOptionCourses = searchOptionCourse;
            }
        },
        handleCourseOptionVisible(scope){
            this.oldCourseName = scope.row.fullName;
        },
        handleCourseChange(scope) {
            this.selectCourseId = (scope.row.courseId+'-'+scope.row.courseName);
            let newCourseName = scope.row.fullName;
            if (newCourseName == null) return;

            for (let i=0; i<this.optionCourses.length; ++i) {
                if (this.oldCourseName!="" && this.oldCourseName===this.optionCourses[i].value) {
                    this.optionCourses[i].disabled = false;
                }

                if (newCourseName === this.optionCourses[i].value) {
                    this.optionCourses[i].disabled = true;
                    scope.row.score = this.optionCourses[i].credit;
                    scope.row.totalTime = this.optionCourses[i].totalTime;
                    scope.row.theoryTime = this.optionCourses[i].theoryTime;
                    scope.row.practiseTime = this.optionCourses[i].practiseTime;
                    scope.row.courseCategoryName = this.optionCourses[i].courseCategoryName;
                    scope.row.sfjjkc = this.optionCourses[i].sfjjkc;
                    if(scope.row.sfjjkc=="0"){
                        scope.row.sfjjkcmc = "否";
                    }else{
                        scope.row.sfjjkcmc = "是";
                    }

                }
            }
            scope.row.courseId = newCourseName.split("-")[0];
            scope.row.courseName = newCourseName.split("-")[1];
            // if(scope.row.sfjjkc=="1"){
            //      scope.row.courseName += " [进阶课程]";
            // }
        },
        handleExamTypeChange(scope){
            let examTypeCode = scope.row.examType;
            let examTypeName = '';
            for(let i=0; i<this.examType.length; i++){
                if(examTypeCode === this.examType[i].comboValue){
                    examTypeName = this.examType[i].comboName;
                    break;
                }
            }
            scope.row.examTypeName = examTypeName;
        },
        formatterNumShow(str) {
            if (str == "0") str = "";

            return str;
        },
        formatterNumHour(term,week){
            let str = "";
            if (week == "0" || week == ""){
                if (term == "0" || term == ""){
                    str = "";
                } else {
                    str = term;
                }
            } else {
                if (term == "0" || term == ""){
                    str = "";
                } else {
                    str = term+" / "+week;
                }
            }
            return str;
        },
        handleRowClick(refName, row, column, event) {
            //不可编辑处理
            if(this.editDisableState){
                //this.$refs.CAPTable.setCurrentRow();
            }
            this.jxjcRowData = row;
        },
        getSummaries(param) {
            //统计求和函数
            const { columns, data } = param;
            const sums = [];

            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "合计";
                    return;
                }
                if (index===1 || index===2 || index===3 || index===4 ||index===9) {
                    sums[index] = "";
                    return;
                }

                const values = data.map(function (item) {
                    if(item.sfjjkc!=""){
                        if(item.sfjjkc=="0"){
                            return Number(item[column.property]);
                        }else{
                            return 0;
                        }
                    }else{
                        return Number(item[column.property]);
                    }
                });
                if (!values.every((value) => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                } else {
                    sums[index] = "";
                }

                // let minus = 0;
                // for(let i=0;i<data.length;i++){
                //     if(data[i].sfjjkc=="1"){

                //     }
                // }
            });
            return sums;
        },
        submitJxjc(){
            if (this.jxjcRowData == null) {
                this.$message({
                    title: '提示',
                    message: '请选择一条数据！',
                    type: 'warning',
                    duration: 2000,
                });
                return;
            }
            this.$emit("getJxjcInfo", this.jxjcRowData);
        },
        closeJxjcDialog(){
            this.$emit("closeJxjcInfoDialog");
        },
    },
};
</script>

<style scoped>
    .numbers {
        width: 80%;
    }

    .tb-edit .el-edit {
        display: none;
    }

    .tb-edit .current-row .el-edit {
        display: block;
    }

    .tb-edit .current-row .el-edit + span {
        display: none;
    }

    .courseContent .el-table {
        overflow: visible;
    }

    .stickyContent {
        background-color: #ffffff;
        position: -webkit-sticky;
        position: sticky;
        z-index: 9999;
    }

    ..tb-edit .el-table__body tr.current-row>td.el-table__cell {
        background-color: #ecf5ff !important;
    }
</style>



// WEBPACK FOOTER //
// editCourseAndProgress.vue?0420a24c